import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=3cb61e44&scoped=true&"
import script from "./ReservationDetails.vue?vue&type=script&lang=js&"
export * from "./ReservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=3cb61e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb61e44",
  null
  
)

export default component.exports